module.exports = __webpack_public_path__ + "static/media/dash-camp.c87b997c.png";